"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardRoles = exports.PermissionType = exports.StandardPermissionsGroupCategories = void 0;
var StandardPermissionsGroupCategories;
(function (StandardPermissionsGroupCategories) {
    StandardPermissionsGroupCategories["LIBRARY"] = "LIBRARY";
    StandardPermissionsGroupCategories["OUTREACH_PAGE"] = "OUTREACH_PAGE";
    StandardPermissionsGroupCategories["OUTREACH"] = "OUTREACH";
    StandardPermissionsGroupCategories["POLCO_LIVE"] = "POLCO_LIVE";
    StandardPermissionsGroupCategories["POLLS"] = "POLLS";
    StandardPermissionsGroupCategories["PROFILES"] = "PROFILES";
    StandardPermissionsGroupCategories["SETTINGS"] = "SETTINGS";
    StandardPermissionsGroupCategories["SURVEYS"] = "SURVEYS";
    StandardPermissionsGroupCategories["SURVEY_RESULTS"] = "SURVEY_RESULTS";
    StandardPermissionsGroupCategories["PARTICIPANTS"] = "PARTICIPANTS";
    StandardPermissionsGroupCategories["BALANCING_ACT"] = "BALANCING_ACT";
    StandardPermissionsGroupCategories["DATA_POINTS"] = "DATA_POINTS";
    StandardPermissionsGroupCategories["SUBSCRIPTIONS"] = "SUBSCRIPTIONS";
})(StandardPermissionsGroupCategories || (exports.StandardPermissionsGroupCategories = StandardPermissionsGroupCategories = {}));
var PermissionType;
(function (PermissionType) {
    // Profiles
    PermissionType["ADD_INITIAL_PROFILE_ADMINS"] = "ADD_INITIAL_PROFILE_ADMINS";
    PermissionType["TOGGLE_PROFILE_FEATURES"] = "TOGGLE_PROFILE_FEATURES";
    PermissionType["SWITCH_BETWEEN_PROFILES"] = "SWITCH_BETWEEN_PROFILES";
    PermissionType["EDIT_MAIN_PROFILE"] = "EDIT_MAIN_PROFILE";
    PermissionType["SAMPLE_SURVEY_SETTINGS"] = "SAMPLE_SURVEY_SETTINGS";
    // Settings
    PermissionType["ADD_ADMINS"] = "ADD_ADMINS";
    PermissionType["REMOVE_ADMINS"] = "REMOVE_ADMINS";
    PermissionType["ASSIGN_ROLES_TO_ADMINS"] = "ASSIGN_ROLES_TO_ADMINS";
    // Library
    PermissionType["VIEW_LIBRARY"] = "VIEW_LIBRARY";
    PermissionType["COPY_LIBRARY_CONTENT"] = "COPY_LIBRARY_CONTENT";
    // Outreach (at profile level)
    PermissionType["OUTREACH_SHAREABLE_URL"] = "OUTREACH_SHAREABLE_URL";
    PermissionType["OUTREACH_EMAIL_LISTS"] = "OUTREACH_EMAIL_LISTS";
    // Surveys
    PermissionType["CREATE_SURVEY"] = "CREATE_SURVEY";
    PermissionType["EDIT_SURVEY"] = "EDIT_SURVEY";
    PermissionType["PUBLISH_SURVEY"] = "PUBLISH_SURVEY";
    PermissionType["PRINTABLE_PREVIEW"] = "PRINTABLE_PREVIEW";
    PermissionType["DELETE_SURVEY"] = "DELETE_SURVEY";
    PermissionType["COPY_SURVEY"] = "COPY_SURVEY";
    PermissionType["VIEW_SURVEY_RESULTS"] = "VIEW_SURVEY_RESULTS";
    PermissionType["VIEW_ALL_SURVEYS_UNDER_PROFILE"] = "VIEW_ALL_SURVEYS_UNDER_PROFILE";
    PermissionType["VIEW_NOT_STARTED_SURVEY"] = "VIEW_NOT_STARTED_SURVEY";
    PermissionType["VIEW_IN_PROGRESS_SURVEY"] = "VIEW_IN_PROGRESS_SURVEY";
    PermissionType["VIEW_CLOSED_SURVEY"] = "VIEW_CLOSED_SURVEY";
    // Poll sets
    PermissionType["CREATE_POLL_SET"] = "CREATE_POLL_SET";
    PermissionType["EDIT_POLL_SET"] = "EDIT_POLL_SET";
    PermissionType["DELETE_POLL_SET"] = "DELETE_POLL_SET";
    PermissionType["COPY_POLL_SET"] = "COPY_POLL_SET";
    PermissionType["VIEW_ALL_POLL_SETS_UNDER_PROFILE"] = "VIEW_ALL_POLL_SETS_UNDER_PROFILE";
    PermissionType["VIEW_NOT_STARTED_POLL_SETS"] = "VIEW_NOT_STARTED_POLL_SETS";
    PermissionType["VIEW_IN_PROGRESS_POLL_SETS"] = "VIEW_IN_PROGRESS_POLL_SETS";
    PermissionType["VIEW_CLOSED_POLL_SET"] = "VIEW_CLOSED_POLL_SET";
    // Polls (children of polls sets)
    PermissionType["CREATE_POLL"] = "CREATE_POLL";
    PermissionType["EDIT_POLL"] = "EDIT_POLL";
    PermissionType["PUBLISH_POLL"] = "PUBLISH_POLL";
    PermissionType["SHARE_INDIVIDUAL_POLL"] = "SHARE_INDIVIDUAL_POLL";
    PermissionType["DELETE_POLL_FROM_SET"] = "DELETE_POLL_FROM_SET";
    PermissionType["VIEW_POLL_RESULTS"] = "VIEW_POLL_RESULTS";
    PermissionType["VIEW_DRAFT_POLL"] = "VIEW_DRAFT_POLL";
    PermissionType["VIEW_READY_TO_PUBLISH_POLL"] = "VIEW_READY_TO_PUBLISH_POLL";
    PermissionType["VIEW_PUBLISHED_POLL"] = "VIEW_PUBLISHED_POLL";
    PermissionType["VIEW_CLOSED_POLL"] = "VIEW_CLOSED_POLL";
    // Polco live events
    PermissionType["CREATE_LIVE_EVENT"] = "CREATE_LIVE_EVENT";
    PermissionType["EDIT_LIVE_EVENT"] = "EDIT_LIVE_EVENT";
    PermissionType["MAKE_LIVE_EVENT_VISIBLE"] = "MAKE_LIVE_EVENT_VISIBLE";
    PermissionType["PUBLISH_START_LIVE_EVENT"] = "PUBLISH_START_LIVE_EVENT";
    PermissionType["DELETE_LIVE_EVENT"] = "DELETE_LIVE_EVENT";
    PermissionType["COPY_LIVE_EVENT"] = "COPY_LIVE_EVENT";
    PermissionType["VIEW_ALL_LIVE_EVENTS_UNDER_SAME_PROFILE"] = "VIEW_ALL_LIVE_EVENTS_UNDER_SAME_PROFILE";
    PermissionType["VIEW_NOT_STARTED_LIVE_EVENT"] = "VIEW_NOT_STARTED_LIVE_EVENT";
    PermissionType["VIEW_IN_PROGRESS_LIVE_EVENT"] = "VIEW_IN_PROGRESS_LIVE_EVENT";
    PermissionType["VIEW_CLOSED_LIVE_EVENT"] = "VIEW_CLOSED_LIVE_EVENT";
    // Polco live event polls (children of live events)
    PermissionType["CREATE_LIVE_POLL"] = "CREATE_LIVE_POLL";
    PermissionType["PUBLISH_LIVE_POLL"] = "PUBLISH_LIVE_POLL";
    PermissionType["EDIT_LIVE_POLL"] = "EDIT_LIVE_POLL";
    PermissionType["VIEW_LIVE_RESULTS_AND_COMMENTS_ON_LIVE_POLLS"] = "VIEW_LIVE_RESULTS_AND_COMMENTS_ON_LIVE_POLLS";
    PermissionType["CLOSE_LIVE_POLL_IN_30_SECONDS"] = "CLOSE_LIVE_POLL_IN_30_SECONDS";
    PermissionType["PREVIEW_LIVE_POLL"] = "PREVIEW_LIVE_POLL";
    PermissionType["DELETE_LIVE_POLL"] = "DELETE_LIVE_POLL";
    PermissionType["VIEW_CLOSED_LIVE_POLLS"] = "VIEW_CLOSED_LIVE_POLLS";
    // Outreach (for all types of question sets: surveys, polls and live events)
    PermissionType["SHARE_AND_MANAGE_ACCESS_BUTTON"] = "SHARE_AND_MANAGE_ACCESS_BUTTON";
    PermissionType["SHARE_DIRECT_URL"] = "SHARE_DIRECT_URL";
    PermissionType["MANAGE_ACCESS"] = "MANAGE_ACCESS";
    PermissionType["EMAIL_SUBSCRIBERS_AND_INVITEES"] = "EMAIL_SUBSCRIBERS_AND_INVITEES";
    // Question set results (common to all types of question sets)
    PermissionType["PREPARE_OUTCOME"] = "PREPARE_OUTCOME";
    PermissionType["DOWNLOADABLE_REPORT"] = "DOWNLOADABLE_REPORT";
    PermissionType["VIEW_RESPONDENT_VIEW"] = "VIEW_RESPONDENT_VIEW";
    // Participants
    PermissionType["VIEW_SUBSCRIBER_DASHBOARD"] = "VIEW_SUBSCRIBER_DASHBOARD";
    PermissionType["VIEW_BENCHMARK_DASHBOARD"] = "VIEW_BENCHMARK_DASHBOARD";
    // Balancing Act
    PermissionType["VIEW_BALANCING_ACT_RESULTS_ALL"] = "VIEW_BALANCING_ACT_RESULTS_ALL";
    PermissionType["EDIT_BALANCING_ACT_CONTENT"] = "EDIT_BALANCING_ACT_CONTENT";
    // Saved Data Points
    PermissionType["MANAGE_SAVED_DATA_POINTS"] = "MANAGE_SAVED_DATA_POINTS";
    PermissionType["MANAGE_TRACK_GOALS"] = "MANAGE_TRACK_GOALS";
    // Subscriptions
    PermissionType["MANAGE_SUBSCRIPTIONS"] = "MANAGE_SUBSCRIPTIONS";
    PermissionType["MANAGE_TRACK_DOMAINS"] = "MANAGE_TRACK_DOMAINS";
})(PermissionType || (exports.PermissionType = PermissionType = {}));
var StandardRoles;
(function (StandardRoles) {
    StandardRoles["MANAGER"] = "MANAGER";
    StandardRoles["PUBLISHER"] = "PUBLISHER";
    StandardRoles["COLLABORATOR"] = "COLLABORATOR";
    StandardRoles["VIEWER"] = "VIEWER";
})(StandardRoles || (exports.StandardRoles = StandardRoles = {}));
